import {
  Box, Button, Container, Typography,
} from '@mui/material'
import { useHistory } from 'react-router-dom'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

const TitleWithBackBtn = ({
  title, subTitle, backBtnTxt, children, customStyle, onBack,
}) => {
  const history = useHistory()

  return (
    <Box sx={[styles.root, customStyle]}>
      <Container maxWidth="xl">
        <Box item>
          <Button onClick={onBack || (() => history.goBack())} sx={styles.backLink} className='backBtn'>
            <ArrowBackIosNewIcon />
            <p>{backBtnTxt}</p>
          </Button>
        </Box>

        <Box sx={[styles.titleContainer, children && styles.titleWithChildren]} className='container'>
          <Box sx={styles.mainTitle} className='mainTitle'>
            <Typography variant="h5" sx={styles.title}>{title}</Typography>
            {subTitle && <Typography variant="body1">{subTitle}</Typography>}
          </Box>

          {children}
        </Box>
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    backgroundColor: 'white',
    padding: { xs: '15px 0px 0px', sm: '15px 0' },
    marginTop: { xs: '0px', sm: '-30px' },
    marginBottom: { xs: '0px', sm: '30px' },
    height: '90px',
  },
  backLink: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'capitalize',
    color: '#90979E',
    textDecoration: 'unset',
    backgroundColor: 'white !important',
    margin: '0',
    padding: '0',
    fontSize: '12px',
    marginBottom: '5px',

    '& p': {
      margin: '0',
    },

    '& svg': {
      height: '11px',
    },
  },
  titleContainer: {
    marginLeft: '20px',
    textTransform: 'capitalize',
    '& h5': {
      fontSize: { xs: '16px', sm: '24px' },
      fontFamily: 'Avenir',
      fontWidth: '700',
    },

    '& p': {
      fontSize: '14px',
      color: '#98a9bc !important',
    },
  },
  mainTitle: {
    minWidth: 'fit-content',
  },
  titleWithChildren: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}

export default TitleWithBackBtn
